import React from 'react';
import clsx from 'clsx';
import { PositionStatus } from '@models/winnerSelection/ITablePositions';
import { statusLabel } from '../utils/posInfoMerge';

/**
 * Pill-чип статуса позиции в шапке.
 * - decided → success-tint (зелёный)
 * - in-progress → warning-tint (defaults без модификатора)
 * - todo → нейтральный
 */
export const PositionStatusPill: React.FC<{ status: PositionStatus }> = ({ status }) => (
    <span
        className={clsx('ws-pos-head__state-pill', {
            'ws-pos-head__state-pill--decided': status === 'decided',
            'ws-pos-head__state-pill--todo': status === 'todo',
        })}
    >
        {statusLabel(status)}
    </span>
);
